export const ORGANIZATION_STATUSES = {
  UNVERIFIED: 'unverified',
  VERIFIED: 'verified',
} as const;

export type OrganizationStatus = (typeof ORGANIZATION_STATUSES)[keyof typeof ORGANIZATION_STATUSES];
